import React, { useEffect } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";

import { url } from "../../../services/constant";

import { useTheme, useLoyalty } from "../../../hooks";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

//svgs
import {
  Curve,
  CurveOverImage,
  NewBackButton,
  Phone,
  RightArrow,
  Time as TimeIcon,
  VoiceIcon,
} from "../../../components/svgs";
import {
  Button,
  CurveHolder,
  Span,
  StyledText,
} from "../../../components/common/basic";

const note = [
  "You must be at the Ogua festival.",
  "You need to answer all 10 questions correctly in 90 seconds to stand a chance of winning a free voucher.",
  "The first participants to answer all questions correctly will win a free voucher.",
  "Winning the trivia does not guarantee you will win a free voucher.",
  "You have 3 attempts to play the trivia.",
  // "You have to be at James Town, Bukom Astro Turf, Anusan Junction or Accra Sport Stadium to collect your free voucher.",
];

const tips = [
  "Trivia is valid on 1st to 3rd Sep 2023.",
  "Winners will be presented with the prizes at the event.. ",
  "This promo is exclusive on MyMTN App.",
];

const TriviaHome = () => {
  const { themeContext, theme } = useTheme();
  const { setCapture, selectedLoyaltyData } = useLoyalty();
  const { image, banner } = selectedLoyaltyData || {};

  const history = useHistory();

  let themeColor = "background";

  let background = theme.colors[themeContext.activeTheme][themeColor];
  useEffect(() => {
    analytics().then((anl) => logEvent(anl, "trivia_home_view", {}));
  }, []);
  return (
    <>
      <MainHolder>
        <Children>
          <Header>
            <Image src={image || `${url}/assets/images/trivia.jpg`} />
            <Gradient>
              <GradientBody>
                <BackButtonContainer onClick={() => history.goBack()}>
                  <NewBackButton />
                </BackButtonContainer>
                <HeaderContent>
                  <Tag
                    color={theme.colors[themeContext.activeTheme]["background"]}
                  >
                    <StyledText
                      style={{
                        marginBlockStart: 0,
                        marginBlockEnd: 0,
                        padding: 2,
                      }}
                      size={12}
                      color={"white"}
                    >
                      {"Loyalty"}
                    </StyledText>
                  </Tag>
                  <StyledText size={25} color={"white"}>
                    {"Ogua Trivia"}
                  </StyledText>
                  <Button
                    style={{
                      width: "50%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    color={"white"}
                    onClick={() => {
                      setCapture(false);
                      history.push("trivia/vendor");
                    }}
                  >
                    <StyledText style={{ marginRight: 10 }}>
                      Start Trivia
                    </StyledText>
                    <RightArrow />
                  </Button>
                </HeaderContent>
              </GradientBody>
            </Gradient>
          </Header>
          <CurveHolder style={{ zIndex: 1, position: "relative" }}>
            <Curve fill={"white"} />
          </CurveHolder>
          <Body>
            <StyledText style={{ fontFamily: "MTNRegularItalic" }} size={18}>
              <Span fontFamily={"bold"}>{`Yo`}</Span>
              {" Peeps"}
            </StyledText>
            <StyledText style={{ fontFamily: "MTNRegular" }}>
              {`Play a game and stand a chance to win a prize now. T&Cs apply.`}
            </StyledText>
            <StyledText size={10}>{`*Terms & Conditions apply*`}</StyledText>{" "}
            <StyledText
              size={18}
              fontFamily={"medium"}
            >{`How to play:`}</StyledText>
            {note.map((note, index) => {
              return (
                <NotesContainer key={index}>
                  <CircleContainer>
                    <Dot color={background} />
                  </CircleContainer>
                  <StyledText
                    style={{ marginBlockStart: 0, fontFamily: "MTNRegular" }}
                  >
                    {note}
                  </StyledText>
                </NotesContainer>
              );
            })}
            <Button
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginInline: 15,
              }}
              color={background}
              onClick={() => {
                setCapture(false);
                history.push("/privacy");
              }}
            >
              <StyledText style={{ marginRight: 10 }} color={"white"}>
                Terms & Conditions
              </StyledText>
            </Button>
          </Body>
          <CurveOverImage
            style={{ position: "relative", zIndex: 1, marginTop: -10 }}
            fill={"white"}
          />
          <FooterImageContainer>
            <FooterImage
              src={banner || `${url}/assets/images/trivia-banner.jpg`}
            />
          </FooterImageContainer>
          <CurveHolder style={{ position: "relative", zIndex: 1 }}>
            <Curve fill={background} />
          </CurveHolder>
          <FooterContainer activeTheme={background}>
            <StyledText size={16} color={"white"}>
              Here are some tips
            </StyledText>
            <TipsContainer>
              {tips.map((tip, index) => {
                const icons = [
                  <TimeIcon width={25} height={25} />,
                  <VoiceIcon width={25} height={25} fill={"black"} />,
                  <Phone width={25} height={25} />,
                ];
                return (
                  <TipContainer key={index}>
                    {icons[index]}
                    <Divider />
                    <StyledText size={11} color={"black"}>
                      {tip}
                    </StyledText>
                  </TipContainer>
                );
              })}
            </TipsContainer>
          </FooterContainer>
        </Children>
      </MainHolder>
    </>
  );
};

const MainHolder = styled.div`
  display: grid;
  align-content: space-between;
  grid-template-rows: auto auto 1fr;
  overflow: hidden;
  scrollbar-width: none;
  background-color: ${({ activeTheme }) => activeTheme};
  height: 700px;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Children = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const Header = styled.div`
  /* width: 360px; */
  height: 300px;
  overflow: hidden;
  position: relative;
`;

const Gradient = styled.div`
  width: 100%;
  height: 300px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.17) 39.58%,
    #000000 100%
  );
  position: absolute;
  z-index: 1;
  display: grid;
  grid-auto-flow: column;
  align-items: flex-start;
  padding: 5px;
`;

const Image = styled.img`
  /* width: 380px; */
  height: 400px;
  margin: 0 0 0 0px;
  position: absolute;
`;

const GradientBody = styled.div`
  padding: 5px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 80%;
`;

const BackButtonContainer = styled.div`
  background-color: #ffcc00;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeaderContent = styled.div``;

const Tag = styled.div`
  background-color: ${(prop) => prop.color};
  width: min-content;
  padding: 1px;
  margin-block-start: 0;
  margin-block-end: 0;
`;

const Body = styled.div`
  padding: 10px;
`;

const NotesContainer = styled.div`
  display: flex;
`;

const CircleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding-inline: 10px;
  margin-top: 5px;
`;

const Dot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${({ color }) => color};
  margin-right: 10px;
`;

const FooterImageContainer = styled.div`
  width: 100%;
  height: 250px;
  overflow: hidden;
  margin-top: -63px;
`;

const FooterImage = styled.img`
  width: 430px;
  height: 400px;
  margin: -155px -35px 0 0;
  /* position: absolute; */
`;

const FooterContainer = styled.div`
  background-color: ${({ activeTheme }) => activeTheme};
  padding: 20px;
  margin-top: -20px;
`;

const TipsContainer = styled.div`
  display: flex;
  margin-bottom: 10px;
`;

const TipContainer = styled.div`
  width: 125px;
  height: 120px;
  border-radius: 10px;
  background-color: white;
  padding: 2px;
  margin-right: 10px;
`;

const Divider = styled.div`
  height: 1px;
  background-color: black;
`;

export default TriviaHome;
